import { inject } from 'vue';
import { appContextSymbol } from './app-context';
import type { AppContext } from './app-context';

/**
 * Method to inject the appContext, such as locale and isWebview
 * Need to import every time we need to check locale or isWebview.
 *
 * TODO: Think about other, more convenient and clear way to pass appContext,
 * so we don't need to import it every time
 *
 * @see https://tracker.yandex.ru/TOURTEAM-804
 */
export function injectAppContext() {
  const appContext = inject(appContextSymbol);

  if (!appContext) {
    throw new Error('App context controller was not provided');
  }

  return appContext as AppContext;
}
